var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.size,attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('action')}}},[_vm._t("default"),_c('img',{attrs:{"src":require("../assets/images/icons/right-arrow.svg"),"alt":"Right arrow"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }